import { esDoubleBedroomsPalettes } from "../../../../Posts/05-tematicas/04-dormitorios-matrimoniales-modernos/doubleBedroomsPalettes.js";
import * as React from 'react';
export default {
  esDoubleBedroomsPalettes,
  React
};